/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from 'react'
import Sidebaar from '../Components/Sidebar'
import { Col, Form, Modal } from 'react-bootstrap'
import { getdata, imgurl, isVideoFile, postdata } from '../Api/Api'
import axios from 'axios'
import { BaseUrl } from '../Url'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'
import { toast } from 'react-toastify'
import Loader from '../Components/Loader'
import { MdOutlineClose } from "react-icons/md";


function ProductEdit() {
    const { state } = useLocation();

    const [categorydata, setcategorydata] = useState([])

    const { url } = useParams()
    const [pdfFile, setPdfFile] = useState(null);

    const navigate = useNavigate()
    const [data, setdata] = useState([])
    const [subcatdata, setsubcatdata] = useState([])
    const [title, settitle] = useState("")
    const [start_at, setstart_at] = useState("")
    const [end_at, setend_at] = useState("")
    const [detail, setdetail] = useState("")
    const [file, setfile] = useState([])
    const [imgpreview, setimgpreview] = useState([])
    const [loading, setloading] = useState(false)

    const [editid, seteditid] = useState("")
    const [showmodal, setshowmodal] = useState(false);
    const handleClose = () => setshowmodal(false);


    const [cat, setcat] = useState("")
    const [subcat, setsubcat] = useState("")
    const handlecategory = async () => {
        const res = await getdata('category')
        setcategorydata(res.data)
    }

    // const handleproductfetch = () => {
    //     axios.get(`${BaseUrl}/product/view/${url}`, { headers }).then((res) => {
    //         console.log("productdata", res.data.data)
    //         const productData = res.data.data;
    //         setdata(res.data.data)
    //         seteditid(productData?._id)
    //         setcat(productData?.category_id)
    //         setsubcat(productData?.subcategory_id?._id)
    //         setimgpreview(productData.images)
    //         settitle(productData?.title)
    //         setstart_at(moment(productData?.start_at).format("YYYY-MM-DDTHH:mm"))

    //         setend_at(moment(productData?.end_at).format("YYYY-MM-DDTHH:mm"))
    //         setdetail(productData?.description)
    //     })
    // }

    console.log(state);
    const handleEdit = () => {
        const productData = state.item;
        setdata(state.item)
        seteditid(productData?._id)
        setcat(productData?.category_id._id)
        setsubcat(productData?.subcategory_id?._id)
        setimgpreview(productData.images)
        settitle(productData?.title)
        setstart_at(moment(productData?.start_at).format("YYYY-MM-DDTHH:mm"))
        setend_at(moment(productData?.end_at).format("YYYY-MM-DDTHH:mm"))
        setdetail(productData?.description)
    };

    useEffect(() => {
        if (state) {
            handleEdit()
        }
    }, [state])

    let token = localStorage.getItem("token")
    const headers = {
        Authorization: `Bearer ${token}`
    }


    const handlesub = async () => {
        let requestdata = {
            category_id: cat
        }
        axios.post(`${BaseUrl}/subcategory/get`, requestdata, { headers }).then((res) => {
            setsubcatdata(res.data.data.sub_category)
        })

    }

    useEffect(() => {
        handlecategory()
        // handleproductfetch()
    }, [])

    useEffect(() => {
        if (categorydata.length > 0) {
            handlesub()
        }
    }, [cat])




    const handleAllImagesRemove = (e) => {
        e.preventDefault();
        setfile([])

        document.getElementById("image-input").value = "";
    };


    const handlefile = (e) => {
        const selectedFiles = Array.from(e.target.files);
        // Update the state with the selected files
        setfile(selectedFiles);

        // You can also log each selected file if needed
        selectedFiles.forEach(file => {
            console.log('Selected file:', file);
        });
    };


    const handlepdf = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            const validTypes = [
                "application/pdf",
                "application/vnd.ms-excel", // .xls MIME type
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // .xlsx MIME type
            ];

            if (validTypes.includes(file.type)) {
                setPdfFile(file); // Save the file to state
            } else {
                toast.error("Please select a valid PDF or Excel file."); // Alert for invalid files
                setPdfFile(null); // Reset state
            }
        }
    };


    const handleSubmit = async (e) => {
        setloading(true)
        e.preventDefault();
        let requestData = {
            product_id: editid,
            category_id: cat,
            subcategory_id: subcat,

            title: title,

            start_at: start_at,
            end_at: end_at,
            description: detail,

        };

        axios.put(`${BaseUrl}/product/update`, requestData, { headers })
            .then((res) => {

                if (res.data.data != "") {
                    toast.success("Data Submit Successfully")
                    navigate("/allproduct")
                }
            })
            .catch((error) => {
                console.error("Error:", error);

            })
    };




    const handleimage = (e) => {
        e.preventDefault();
        setloading(true);
        const formData = new FormData();

        formData.append("product_id", editid);
        formData.append("catalog", pdfFile)
        formData.append("user_id", state?.item?.user_id?._id)

        file.forEach((file) => {
            formData.append("images", file);
        });

        axios.post(`${BaseUrl}/product/admin-update-images`, formData, { headers }).then((res) => {
            if (res.data.is_success == "1") {
                toast.success("Images uploaded successfully");
                setshowmodal(false);
                navigate(`/allproduct`);
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Image upload failed");
        }).finally(() => {
            setloading(false);
        });
    };

    const handleremoveimage = async (id) => {
        console.log(id)
        axios.delete(`${BaseUrl}/product/delete-image/${id}`).then(resp => {
            console.log("deleted successfully", resp.data)
            if (resp.data.error === 0) {
                toast.success("Image delete successfully!")
                setimgpreview(prevImages => prevImages.filter(img => img._id !== id));
            } else {
                toast.error(resp.message)
            }
        })

    }

    return (
        <>
            {loading && <Loader />}
            <Sidebaar content={
                <>


                    <Form onSubmit={(e) => handleSubmit(e)}>
                        <div className="row gy-3 align-items-center">
                            <div className="col-md-12">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-md-8">
                                        <div className="bg-white shadow p-3 rounded-3">
                                            <div className="row align-items-center">
                                                <div className="col-md-2">
                                                    <div className="">
                                                        <img className='img-fluid ' style={{ width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover", boxShadow: "0 0 0 4px #ddd" }} src={`${imgurl}/${data?.user_id?.profile_image}`} alt="" />
                                                    </div>
                                                </div>
                                                <div className="col-md-10">
                                                    <h3>User Detail</h3>
                                                    <h5><span>Name</span> :  <span className='text-success text-capitalize '>{data?.user_id?.name}</span></h5>
                                                    <h5><span>Business Name</span> : <span className='text-success text-capitalize '>{data?.user_id?.business_name}</span></h5>
                                                    <h5><span>Address</span> :  <span className='text-success text-capitalize '>{data?.location?.city}, {data?.location?.state} ,{data?.location?.pincode}</span></h5>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <h3>Edit Product</h3>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex justify-content-end">
                                    <button type='button' class="btn bg-green text-end text-white px-5 ms-4" onClick={() => setshowmodal(true)}>Upload Image</button>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="">Category</label>
                                <select name="" value={cat} onChange={(e) => setcat(e.target.value)} className='form-control shadow-none form-select' id="">
                                    <option value="">--Select--</option>
                                    {categorydata.map((item) => {
                                        return (
                                            <>
                                                <option value={item._id}>{item.title}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>
                            {/* <div className="col-md-4">
                                <label htmlFor="">Sub Category</label>
                                <select name="" value={subcat} onChange={(e) => setsubcat(e.target.value)} className='form-control shadow-none form-select' id="">
                                    <option value="" >--Select--</option>
                                    {subcatdata?.map((item) => {
                                        return (
                                            <>
                                                <option value={item._id}>{item.title}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div> */}
                            <div className="col-md-4">
                                <label htmlFor="">Title</label>
                                <input type="text" className='form-control' value={title} onChange={(e) => settitle(e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="">Start At</label>

                                <input type="datetime-local" className='form-control' value={start_at} onChange={(e) => setstart_at(e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <label htmlFor="">End At</label>

                                <input type="datetime-local" className='form-control' value={end_at} onChange={(e) => setend_at(e.target.value)} />
                            </div>

                            {/* <div className="col-md-4">
                                <label htmlFor="">Images</label>

                                <input type="file" multiple className='form-control' onClick={() => handleimage(editid)} onChange={(e) => handlefile(e)} />
                            </div> */}
                            <div className="col-md-12">
                                <label htmlFor="">Description</label>

                                <textarea name="" value={detail} onChange={(e) => setdetail(e.target.value)} className='form-control' id=""></textarea>
                            </div>
                            <div className="col-md-12">
                                <button class="btn bg-green text-white px-5">Submit</button>

                            </div>
                            <div className="col-md-12">
                                {file.length > 0 ? <Col md="12">
                                    <div className="">
                                        {file.length > 0 && (
                                            <button
                                                onClick={handleAllImagesRemove}
                                                className="remove-all-button btn mb-2 text-white bg-warning"
                                                style={{ fontSize: "12px" }}
                                            >
                                                Remove All Images
                                            </button>
                                        )}
                                        <div className="d-flex align-items-center gap-2">
                                            {file.map((image, index) => (
                                                <div key={index} className="image-preview">
                                                    <img
                                                        id='image-input'
                                                        src={URL.createObjectURL(image)}
                                                        className="img-fluid"
                                                        style={{ height: "200px", borderRadius: "10px" }}
                                                        alt={`Image ${index + 1}`}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Col> : <Col md="12">
                                    <div className="">
                                        <div className="d-flex align-items-center gap-2">
                                            {imgpreview.map((image, index) => (
                                                <div key={index} className="image-preview position-relative">
                                                    <div className="btn btn-danger position-absolute" onClick={() => handleremoveimage(image._id)} style={{ right: 0, top: -14 }}>
                                                        <MdOutlineClose />
                                                    </div>
                                                    {isVideoFile(image.image) ? (
                                                        <video
                                                            src={`${imgurl}/${image.image}`}
                                                            controls
                                                            muted
                                                            className="img-fluid"
                                                            style={{ height: "200px", width: "200px", objectFit: "contain", borderRadius: "10px" }}
                                                        />
                                                    ) : (
                                                        <img
                                                            id='image-input'
                                                            src={`${imgurl}/${image.image}`}
                                                            className="img-fluid"
                                                            style={{ height: "200px", width: "200px", objectFit: "contain", borderRadius: "10px" }}
                                                            alt={`Image ${index + 1}`}
                                                        />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Col>}
                            </div>
                        </div>
                    </Form>
                    <Modal show={showmodal} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Upload Image</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleimage}>
                                <div className="col-md-12 mb-2">
                                    <label htmlFor="">Images</label>
                                    <input type="file" multiple className='form-control' onChange={(e) => handlefile(e)} />

                                    <div className="mt-3">
                                        <label htmlFor="">Pdf / Excel</label>
                                        <input
                                            type="file"
                                            className='form-control'
                                            onChange={handlepdf}
                                            accept=".pdf,.xls,.xlsx"
                                            placeholder="Upload PDF or Excel"
                                        />
                                    </div>
                                </div>


                                <button className='btn bg-green text-white px-5' type='submit'>Submit</button>

                            </Form>
                        </Modal.Body>

                    </Modal>

                </>
            } />
        </>
    )
}

export default ProductEdit 
